// @flow

import React, { Component } from 'react';

import { setPictureInPictureModeConfig } from '../../base/config';
import { getPictureInPictureModeConfig } from '../../base/config/functions.any';
import { MEDIA_TYPE } from '../../base/media';
import { Watermarks } from '../../base/react';
import { connect } from '../../base/redux';
import { getTrackByMediaTypeAndParticipant } from '../../base/tracks';
import { InviteMore, Subject } from '../../conference';
import { fetchCustomBrandingData } from '../../dynamic-branding';
import { getGifDisplayMode, getGifForParticipant } from '../../gifs/function.any';
import PrismaZoom from '../../react-zoom/index';
import Captions from '../../subtitles/components/web/Captions.web';
import { shouldDisplayTileView } from '../../video-layout';

declare var interfaceConfig: Object;

type Props = {

    /**
     * The user selected background color.
     */
    _customBackgroundColor: string,

    /**
     * The user selected background image url.
     */
    _customBackgroundImageUrl: string,

    /**
     * Fetches the branding data.
     */
    _fetchCustomBrandingData: Function,

    /**
     * Prop that indicates whether the chat is open.
     */
    _isChatOpen: boolean,

    /**
     * Used to determine the value of the autoplay attribute of the underlying
     * video element.
     */
    _noAutoPlayVideo: boolean,

    /**
     * Used to Increase the number of the on click.
     */
    _clickbutton: Number,

    /**
     * Used to Increase the number of the on click.
     */
    _clickbutton1: Number,

    /**
     * Used to _gifSrc.
     */
    _gifSrc: string,

    /**
     * Used to _isPictureInPictureVisible.
     */
    _isPictureInPictureVisible: boolean,

    /**
     * Used to _shouldDisplayTileView.
     */
    _shouldDisplayTileView: boolean,

    /**
     * Used to _videoTrack.
     */
    _videoTrack: Object,
};

type State = {
    zoom?: any
  };

// eslint-disable-next-line valid-jsdoc
/** .
 * Implements a React {@link Component} which represents the large video (a.k.a.
 * The conference participant who is on the local stage) on Web/React.
 *
 * @augments Component
 */
class LargeVideo extends Component<Props, State> {
    /**
     * Constructor for LargeVideo Component.
     * @param {*} props
     */
    constructor(props) {
        super(props);
        this.mainVideoRef = React.createRef();
    }


    /**
     * Implements React's {@link Component#componentDidUpdate}.
     *
     * @inheritdoc
    */
    componentDidUpdate(prevProps) {
        if (prevProps._clickbutton !== this.props._clickbutton) {
        // document.getElementById("clickzoomin").click()
            // eslint-disable-next-line react/no-string-refs
            this.refs.prismaZoom.zoomIn(1);
        } else if (prevProps._clickbutton1 !== this.props._clickbutton1) {
        // document.getElementById("clickzoomout").click()
            // eslint-disable-next-line react/no-string-refs
            this.refs.prismaZoom.zoomOut(1);
        }

        if (this.props._isPictureInPictureVisible && this.props._isPictureInPictureVisible !== prevProps._isPictureInPictureVisible) {
            // this.props._setPictureInPictureModeConfig()
            this.mainVideoRef.current.requestPictureInPicture();
        }

        if (
            (!this.props._isPictureInPictureVisible
                && this.props._isPictureInPictureVisible
                    !== prevProps._isPictureInPictureVisible)
            || (!this.props._shouldDisplayTileView
                && this.props._shouldDisplayTileView
                    !== prevProps._shouldDisplayTileView)
            || (this.props._videoTrack
                && this.props._videoTrack !== prevProps._videoTrack)
        ) {
            // document && document?.exitPictureInPicture && document?.exitPictureInPicture();
        }
    }

    /**
     * LargeVideo ComponentDidMount
     */
    componentDidMount() {
        const mainVideo = this.mainVideoRef.current;

        this.props._fetchCustomBrandingData();

        mainVideo.addEventListener('leavepictureinpicture', () => {
            this.props._setPictureInPictureModeConfig(false);
        });
    }

    // eslint-disable-next-line no-invalid-this
    _onZoomChange = zoom => this.setState({ zoom });

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {React$Element}
     */
    render() {
        const style = this._getCustomSyles();
        const className = `videocontainer${this.props._isChatOpen ? ' shift-right' : ''}`;

        return (
            <div
                className = { className }
                id = 'largeVideoContainer'
                style = { style }>
                <Subject />
                <InviteMore />
                <div id = 'sharedVideo'>
                    <div id = 'sharedVideoIFrame' />
                </div>
                <div id = 'etherpad' />
                <div id = 'genericiframe' />

                <Watermarks />

                <div id = 'dominantSpeaker'>
                    <div className = 'dynamic-shadow' />
                    <div id = 'dominantSpeakerAvatarContainer' />
                </div>
                <div id = 'remotePresenceMessage' />
                <span id = 'remoteConnectionMessage' />
                <div id = 'largeVideoElementsContainer'>
                    <div id = 'largeVideoBackgroundContainer' />

                    {/*
                      * FIXME: the architecture of elements related to the large
                      * video and the naming. The background is not part of
                      * largeVideoWrapper because we are controlling the size of
                      * the video through largeVideoWrapper. That's why we need
                      * another container for the background and the
                      * largeVideoWrapper in order to hide/show them.
                      */}
                    {/* <div id = 'largeVideoWrapper'> */}
                    <PrismaZoom
                        id = 'largeVideoWrapper'
                        onZoomChange = { this._onZoomChange }
                        // eslint-disable-next-line react/no-string-refs
                        ref = 'prismaZoom'
                        // eslint-disable-next-line react-native/no-inline-styles
                        style = {{ width: '100%',
                            height: '100%' }}>
                        <video
                            autoPlay = { !this.props._noAutoPlayVideo }
                            id = 'largeVideo'
                            muted = { true }
                            playsInline = { true }
                            ref = { this.mainVideoRef } />
                    </PrismaZoom>
                    {this._renderGif()}
                    {/* </div> */}
                </div>
                { interfaceConfig.DISABLE_TRANSCRIPTION_SUBTITLES
                    || <Captions /> }
            </div>
        );
    }

    /**
     * Creates the custom styles object.
     *
     * @private
     * @returns {Object}
     */
    _getCustomSyles() {
        const styles = {};
        const { _customBackgroundColor, _customBackgroundImageUrl } = this.props;

        styles.backgroundColor = _customBackgroundColor || interfaceConfig.DEFAULT_BACKGROUND;

        if (_customBackgroundImageUrl) {
            styles.backgroundImage = `url(${_customBackgroundImageUrl})`;
            styles.backgroundSize = 'cover';
        }

        return styles;
    }

    /**
     * Renders GIF.
     *
     * @returns {Component}
     */
    _renderGif() {
        const { _gifSrc } = this.props;

        return _gifSrc
                && <div className = { 'gif-container' }>
                    <img
                        alt = 'GIF'
                        src = { _gifSrc } />
                </div>
        ;
    }
}


/**
 * Maps (parts of) the Redux state to the associated LargeVideo props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    const testingConfig = state['features/base/config'].testing;
    const { backgroundColor, backgroundImageUrl } = state['features/dynamic-branding'];
    const { zoomin, zoomout } = state['features/toolbox'];
    const { isOpen: isChatOpen } = state['features/chat'];
    const { participantId } = state['features/large-video'];
    const { gifUrl: gifSrc } = getGifForParticipant(state, participantId);
    const mode = getGifDisplayMode(state);
    const videoTrackOnLargeVideo = getTrackByMediaTypeAndParticipant(
        state['features/base/tracks'],
        MEDIA_TYPE.VIDEO,
        participantId
    );

    return {
        _customBackgroundColor: backgroundColor,
        _customBackgroundImageUrl: backgroundImageUrl,
        _isChatOpen: isChatOpen,
        _noAutoPlayVideo: testingConfig?.noAutoPlayVideo,
        _clickbutton: zoomin,
        _clickbutton1: zoomout,
        _gifSrc: mode === 'chat' ? null : gifSrc,
        _isPictureInPictureVisible: getPictureInPictureModeConfig(state),
        _shouldDisplayTileView: !shouldDisplayTileView(state),
        _videoTrack: videoTrackOnLargeVideo
    };
}

const _mapDispatchToProps = {
    _fetchCustomBrandingData: fetchCustomBrandingData,
    _setPictureInPictureModeConfig: setPictureInPictureModeConfig
};

export default connect(_mapStateToProps, _mapDispatchToProps)(LargeVideo);
